export const QUEIMA_E_RISCO_MOCK = [
  {
    cnpj_empresa: "12345678912457",
    porcentagem_queima_caixa_pis_cofins_no_periodo: 0,
    porcentagem_queima_caixa_icms_no_periodo: 0,
    porcentagem_risco_assumido_pis_cofins_no_periodo: 0,
    porcentagem_risco_assumido_icms_no_periodo: 29.33886514422647,
    cprod: "972993",
    xprod: "EXEMPLO DE DADO",
    cean: "1111111",
    ncm: "48131000",
    cest: "1400300",
    vprod: 820.27,
    valor_pis: 13.53,
    valor_cofins: 62.34,
    valor_icms: 0,
    queima_caixa_pis_cofins: 0,
    queima_caixa_icms: 0,
    risco_assumido_pis_cofins: 0,
    risco_assumido_icms: 164.06,
  },
  {
    cnpj_empresa: "12345678912457",
    porcentagem_queima_caixa_pis_cofins_no_periodo: 2.0310932798395185,
    porcentagem_queima_caixa_icms_no_periodo: 0,
    porcentagem_risco_assumido_pis_cofins_no_periodo: 0.015642597922662996,
    porcentagem_risco_assumido_icms_no_periodo: 17.591516300363025,
    cprod: "973307",
    xprod: "EXEMPLO DE DADO",
    cean: "1111111",
    ncm: "19053100",
    cest: "1705302",
    vprod: 595.08,
    valor_pis: 9.45,
    valor_cofins: 43.57,
    valor_icms: 20.66,
    queima_caixa_pis_cofins: 1.62,
    queima_caixa_icms: 0,
    risco_assumido_pis_cofins: 0.1,
    risco_assumido_icms: 98.37,
  },
  {
    cnpj_empresa: "12345678912457",
    porcentagem_queima_caixa_pis_cofins_no_periodo: 0,
    porcentagem_queima_caixa_icms_no_periodo: 0,
    porcentagem_risco_assumido_pis_cofins_no_periodo: 3.7354523839319236,
    porcentagem_risco_assumido_icms_no_periodo: 11.545270838176648,
    cprod: "001855",
    xprod: 'EXEMPLO DE DADO"',
    cean: "1111111",
    ncm: "22021000",
    cest: "1711100",
    vprod: 321.5,
    valor_pis: 0,
    valor_cofins: 0,
    valor_icms: 0,
    queima_caixa_pis_cofins: 0,
    queima_caixa_icms: 0,
    risco_assumido_pis_cofins: 23.88,
    risco_assumido_icms: 64.56,
  },
  {
    cnpj_empresa: "12345678912457",
    porcentagem_queima_caixa_pis_cofins_no_periodo: 0,
    porcentagem_queima_caixa_icms_no_periodo: 0,
    porcentagem_risco_assumido_pis_cofins_no_periodo: 12.528156676260794,
    porcentagem_risco_assumido_icms_no_periodo: 0,
    cprod: "974494",
    xprod: "EXEMPLO DE DADO",
    cean: "1111111",
    ncm: "19012010",
    cest: null,
    vprod: 930.93,
    valor_pis: 0,
    valor_cofins: 0,
    valor_icms: 65.17,
    queima_caixa_pis_cofins: 0,
    queima_caixa_icms: 0,
    risco_assumido_pis_cofins: 80.09,
    risco_assumido_icms: 0,
  },
  {
    cnpj_empresa: "12345678912457",
    porcentagem_queima_caixa_pis_cofins_no_periodo: 0,
    porcentagem_queima_caixa_icms_no_periodo: 36.45913530366175,
    porcentagem_risco_assumido_pis_cofins_no_periodo: 9.127455887873857,
    porcentagem_risco_assumido_icms_no_periodo: 0,
    cprod: "976116",
    xprod: "EXEMPLO DE DADO",
    cean: "1111111",
    ncm: "23099010",
    cest: "2200100",
    vprod: 2864.95,
    valor_pis: 36.87,
    valor_cofins: 169.99,
    valor_icms: 573.01,
    queima_caixa_pis_cofins: 0,
    queima_caixa_icms: 573.01,
    risco_assumido_pis_cofins: 58.35,
    risco_assumido_icms: 0,
  },
  {
    cnpj_empresa: "12345678912457",
    porcentagem_queima_caixa_pis_cofins_no_periodo: 0,
    porcentagem_queima_caixa_icms_no_periodo: 0,
    porcentagem_risco_assumido_pis_cofins_no_periodo: 6.405643849330497,
    porcentagem_risco_assumido_icms_no_periodo: 0,
    cprod: "973545",
    xprod: "EXEMPLO DE DADO",
    cean: "1111111",
    ncm: "34025000",
    cest: "1100700",
    vprod: 442.08,
    valor_pis: 0,
    valor_cofins: 0,
    valor_icms: 0,
    queima_caixa_pis_cofins: 0,
    queima_caixa_icms: 0,
    risco_assumido_pis_cofins: 40.95,
    risco_assumido_icms: 0,
  },
  {
    cnpj_empresa: "12345678912457",
    porcentagem_queima_caixa_pis_cofins_no_periodo: 0,
    porcentagem_queima_caixa_icms_no_periodo: 0,
    porcentagem_risco_assumido_pis_cofins_no_periodo: 4.533224877987736,
    porcentagem_risco_assumido_icms_no_periodo: 0,
    cprod: "004935",
    xprod: "EXEMPLO DE DADO",
    cean: "1111111",
    ncm: "21069010",
    cest: null,
    vprod: 1122.9,
    valor_pis: 9.65,
    valor_cofins: 44.47,
    valor_icms: 224.58,
    queima_caixa_pis_cofins: 0,
    queima_caixa_icms: 0,
    risco_assumido_pis_cofins: 28.98,
    risco_assumido_icms: 0,
  },
];
